"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.EverspringMappingSelect = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
/**
 * EverspringMappingSelect - Three cascading dropdowns for Everspring mapping
 *
 * Program -> Specialization -> Track
 * Cascades based on selected academic program's mappings.
 */
const react_1 = require("react");
const everspringMappingApi_1 = require("../helpers/everspringMappingApi");
const Select_1 = require("./Select");
const EverspringMappingSelect = ({ academicProgramId, onProgramChange, onSpecializationChange, onTrackChange, selectedProgram, selectedSpecialization, selectedTrack, disabled = false, }) => {
    const [mappings, setMappings] = (0, react_1.useState)([]);
    const [loading, setLoading] = (0, react_1.useState)(false);
    // Load all mappings when academic program changes
    (0, react_1.useEffect)(() => {
        if (!academicProgramId) {
            setMappings([]);
            return;
        }
        let cancelled = false;
        const loadMappings = () => __awaiter(void 0, void 0, void 0, function* () {
            setLoading(true);
            try {
                const result = yield everspringMappingApi_1.everspringMappingApi.getMappingsByAcademicProgram(academicProgramId);
                if (!cancelled) {
                    setMappings(result);
                }
            }
            catch (_a) {
                if (!cancelled) {
                    setMappings([]);
                }
            }
            finally {
                if (!cancelled) {
                    setLoading(false);
                }
            }
        });
        loadMappings();
        return () => { cancelled = true; };
    }, [academicProgramId]);
    // Extract unique programs
    const programOptions = (0, react_1.useMemo)(() => {
        const programs = [...new Set(mappings.map((m) => m.program))];
        return programs.map((p) => ({ value: p, label: p }));
    }, [mappings]);
    // Extract unique specializations filtered by selected program
    const specializationOptions = (0, react_1.useMemo)(() => {
        if (!selectedProgram)
            return [];
        const specs = [
            ...new Set(mappings
                .filter((m) => m.program === selectedProgram && m.specialization)
                .map((m) => m.specialization)),
        ];
        return specs.map((s) => ({ value: s, label: s }));
    }, [mappings, selectedProgram]);
    // Extract unique tracks filtered by selected program and specialization
    const trackOptions = (0, react_1.useMemo)(() => {
        if (!selectedProgram)
            return [];
        const tracks = [
            ...new Set(mappings
                .filter((m) => m.program === selectedProgram &&
                (!selectedSpecialization || m.specialization === selectedSpecialization) &&
                m.track)
                .map((m) => m.track)),
        ];
        return tracks.map((t) => ({ value: t, label: t }));
    }, [mappings, selectedProgram, selectedSpecialization]);
    const handleProgramChange = (0, react_1.useCallback)((e) => {
        onProgramChange(e.target.value);
        onSpecializationChange('');
        onTrackChange('');
    }, [onProgramChange, onSpecializationChange, onTrackChange]);
    const handleSpecializationChange = (0, react_1.useCallback)((e) => {
        onSpecializationChange(e.target.value);
        onTrackChange('');
    }, [onSpecializationChange, onTrackChange]);
    const handleTrackChange = (0, react_1.useCallback)((e) => {
        onTrackChange(e.target.value);
    }, [onTrackChange]);
    if (!academicProgramId)
        return null;
    return ((0, jsx_runtime_1.jsxs)("div", { className: "everspring-mapping-select", style: { display: 'flex', flexDirection: 'column', gap: '1rem' }, children: [(0, jsx_runtime_1.jsx)(Select_1.Select, { id: "everspring-program", label: "Program", value: selectedProgram, onChange: handleProgramChange, options: programOptions, disabled: disabled || loading || programOptions.length === 0, placeholder: loading ? 'Loading...' : programOptions.length === 0 ? 'No programs available' : 'Select a Program', required: true }), specializationOptions.length > 0 && ((0, jsx_runtime_1.jsx)(Select_1.Select, { id: "everspring-specialization", label: "Specialization", value: selectedSpecialization, onChange: handleSpecializationChange, options: specializationOptions, disabled: disabled || !selectedProgram, placeholder: "Select a specialization (optional)" })), trackOptions.length > 0 && ((0, jsx_runtime_1.jsx)(Select_1.Select, { id: "everspring-track", label: "Track", value: selectedTrack, onChange: handleTrackChange, options: trackOptions, disabled: disabled || !selectedProgram, placeholder: "Select a track (optional)" }))] }));
};
exports.EverspringMappingSelect = EverspringMappingSelect;
exports.default = exports.EverspringMappingSelect;
